export enum TSAnrede {
    HERR = <any> 'HERR',
    FRAU = <any> 'FRAU'
}

export function getTSAnredeValues(): Array<TSAnrede> {
    return [
        TSAnrede.HERR,
        TSAnrede.FRAU,
    ];
}




// WEBPACK FOOTER //
// ./src/app/models/enums/TSAnrede.ts